import React, { useState } from "react";
import { Accordion, Col, Container, Form, Row } from "react-bootstrap";
// css
import styles from "./ClientTasks.module.scss";
import { Link, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { MANAGE_STAFF, MANAGE_STAFF_CLIENT_LIST } from "config/paths";
import moment from "moment";
// import { SingleTaskAccordion } from "components/Accordion/SingleTaskAccordion";
import { useGetSupportStaffClientTasksListQuery } from "store/services/supportStaff";
import { SingleTaskAccordion } from "components/Accordions/SingleTaskAccordion";
import { convertToMomentDate, userFullName } from "helpers/common";
import { CLIENT_TYPE_OPTIONS } from "config/constants";

const ClientTasks = () => {

  const { staffId, taskType, clientId } = useParams();

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", sort: { column: "id", direction: "desc" } });

  const { data, isLoading, isError, isFetching } = useGetSupportStaffClientTasksListQuery({ staffId, clientId, task_type: "single", payload: { page: currentPage, limit: pageSize, }, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const column = [
    {
      head: "Title",
      accessor: "LastName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.associatedTasks?.task_title || "--"}</h6>
      ),
    },
    {
      head: "Date / Time",
      accessor: "date",
      isComponent: true,
      component: (item, ind) => (
        <>{moment(item?.associatedTasks?.task_datetime).format("DD/MM/YY hh:mm A")}</>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 80 }}
          className={`${item?.associatedTasks?.status == "pending"
            ? "redStatus"
            : "greenStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item?.associatedTasks?.status}
        </p>
      ),
    },
    {
      head: "Description",
      accessor: "description",
      isComponent: true,
      component: (item, ind) => (
        <CommonToolTip
          text={item?.associatedTasks?.description || ""}
          component={
            <div className="cell-text-ellipsis">{item?.associatedTasks?.description || "--"}</div>
          }
        />
      ),
    },
    {
      head: "Action",
      accessor: "action",
      isComponent: true,
      component: (item) => {
        return (<div className="ActnBtn d-flex align-items-center  gap-10">
          {/* <Link to={`/manage-parent/clients/taskview/single/${item.ClientDetail.id}/${}`}>  */}
          {/* <Link to={`/manage-parent/clients/taskview/single/${item?.client_id}/${item.associatedTasks?.id}`}>  */}
          {/* <Link to={`/manage-parent/clients/sessionview/single/${staffId}/${clientId}/${item.associatedTasks?.id}`}>  */}
          <Link to={`/manage-staff/clients/taskdetails/${taskType}/${staffId}/${clientId}/${item.associatedTasks?.id}`}>
            <button type="button" className="px-2 d-flex align-items-center justify-content-center commonBtn btn btn-primary" style={{ padding: "0px", height: "30px", minWidth: "70px" }}>
              View Task
            </button>
          </Link>
        </div>
        )
      }
    },
  ];

  const resetFilter = () => {
    setFilter({ search: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };
  const getClientTypeLabel = (clientTypeValue) => {
    const clientType = CLIENT_TYPE_OPTIONS.find(type => type.value === clientTypeValue);
    return clientType ? clientType.label : "--";
  };
  return (
    <>
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid>
          <Row>
            <Col
              lg="12"
              className=""
            >
              <Row>
                <Col lg="12" className="my-3">
                  <div className="my-3">
                    <ul className="list-unstyled mb-0 d-flex align-items-center">
                      <li className="m-0 p-0">
                        <Link
                          className="themeBlue fw-sbold"
                          style={{ textDecoration: "underline" }}
                          to={'/'}
                        >
                          Support Staff
                        </Link>
                      </li>
                      <li className="">
                        <h5 className="m-0 fw-bold themeBlue">
                          / Tasks
                        </h5>
                      </li>
                    </ul>
                  </div>
                  <section className='mt-4'>
                    <Container fluid>
                      <h4 className='m-0 fw-bold themeBlue text-capitalize'>{userFullName(data?.clientDetails?.associatedClient)}</h4>
                      <Row className="mb-5 mt-2">
                        <Col lg='12'>
                          <Row>
                            {[
                              { label: "Last Name", value: data?.clientDetails?.associatedClient?.lastname },
                              { label: "First Name", value: data?.clientDetails?.associatedClient?.firstname },
                              { label: "DOB", value: convertToMomentDate(data?.clientDetails?.associatedClient?.client_detail?.dob) },
                              // { label: "Name of Discipline", value: data?.tasks?.[0]?.associatedTasks?.owner?.therapist_detail?.therapist_discipline?.name },
                              // { label: "Supervisor", value: userFullName(data?.tasks?.[0]?.associatedTasks?.owner) },
                              { label: "School", value: data?.clientDetails?.associatedClient?.client_detail?.client_school_detail?.client_school?.name },
                              { label: "Grade", value: data?.clientDetails?.associatedClient?.client_detail?.grade },
                            ].map((item, index) => (
                              (["Grade", "School"]?.includes(item?.label) && data?.clientDetails?.associatedClient?.client_detail?.client_type == "private") ? null :
                                <Col md="3" sm="6" className='my-2' key={index}>
                                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                    <h6 className="m-0 themeBlue fw-bold">
                                      <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                      {item.label}
                                    </h6>
                                    <p className="m-0 themeBlue pt-2">{item.value || "--"}</p>
                                  </div>
                                </Col>
                            ))}

                            {/* {
                              data?.clientDetails?.associatedClient?.client_detail?.client_type == "school" &&
                              <Col md="3" sm="6" className='my-2'>
                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                  <h6 className="m-0 themeBlue fw-bold">
                                    <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                    School
                                  </h6>
                                  <p className="m-0 themeBlue pt-2">{data?.clientDetails?.associatedClient?.client_detail?.client_school_detail?.client_school?.name || "--"}</p>
                                </div>
                              </Col>
                            } */}


                            {data?.clientDetails?.associatedClient?.client_detail?.client_type == "private" && data?.clientDetails?.associatedClient?.client_detail?.client_guardian_mapping?.map((item, index) => (
                              (item?.label == "Grade" && data?.clientDetails?.associatedClient?.client_detail?.client_type == "private") ? null :
                                <Col md="3" sm="6" className='my-2' key={index}>
                                  <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                    <h6 className="m-0 themeBlue fw-bold">
                                      <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                      {`${item?.client_guardian?.client_role?.title} ${index + 1}`}
                                    </h6>
                                    <p className="m-0 themeBlue pt-2">{userFullName(item.client_guardian) || "--"}</p>
                                  </div>
                                </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    </Container>
                  </section>
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left">
                      <TableHeader
                        heading={"Tasks"}
                        handleFilterChange={handleFilterChange}
                        filter={filter}
                        resetFilter={resetFilter}
                        searchPlaceholder="Title"
                      />
                    </div>
                  </div>
                </Col>
                {/* <Col lg="12" className="my-3">
                  <div className="table-outer">
                    {isLoading ? (
                      <div style={{ height: "200px" }}>
                        <LoadingIndicator />
                      </div>
                    ) : isError ? (
                      <ErrorComponent />
                    ) : (
                      <>
                        {(isFetching) && <LoadingOverlay />}
                        <TableLayout
                          data={data?.records || []}
                          column={column}
                        />
                      </>
                    )}

                  </div>
                </Col> */}

                <Col lg="12" className="my-3">
                  <div className="table-outer">
                    {isLoading ? (
                      <div style={{ height: "200px" }}>
                        <LoadingIndicator />
                      </div>
                    ) : isError ? (
                      <ErrorComponent />
                    ) : (
                      <>
                        {(isFetching) && <LoadingOverlay />}
                        <div className="mb-4">
                          <SingleTaskAccordion tasks={data?.tasks} staffId={staffId} taskType={taskType} clientId={clientId} />
                        </div>
                        <CstmPagination
                          totalPages={totalPages}
                          activePage={currentPage}
                          handlePageChange={handlePageChange}
                        />
                      </>
                    )}

                  </div>
                </Col>
                {/* <Col lg="12" className="my-3">
                  <div className="mb-4">
                    <SingleTaskAccordion tasks={data?.records} staffId={staffId} taskType={taskType} clientId={clientId} />
                  </div>
                  <CstmPagination
                    totalPages={totalPages}
                    activePage={currentPage}
                    handlePageChange={handlePageChange}
                  />
                </Col> */}
              </Row>
            </Col>
          </Row>

        </Container>
      </section>
    </>
  );
};

export default ClientTasks;